import React from "react";
import Navbar from "@/components/wedding/Navbar";
import FloralFrame from "@/components/wedding/FloralFrame";
import Hero from "@/components/wedding/Hero";
import Pagnes from "@/components/wedding/Pagnes";
import Programme from "@/components/wedding/Programme";
import Countdown from "@/components/wedding/Countdown";
import Rsvp from "@/components/wedding/Rsvp";
import Footer from "@/components/wedding/Footer";

export default function Wedding() {
  return (
    <main data-testid="wedding-landing" className="relative paper-bg">
      <FloralFrame />
      <Navbar />
      <div className="relative z-10 template-content">
        <Hero />
        <Countdown />
        <Pagnes />
        <Programme />
        <Rsvp />
      </div>
      {/* Footer breaks out of the template-content wrapper so its
          emerald banner covers the full image width. */}
      <div className="relative z-10">
        <Footer />
      </div>
    </main>
  );
}
